// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DriveTimeDeviations .deviations-card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}
.DriveTimeDeviations .deviations-card .card-body {
  padding: 0;
}
.DriveTimeDeviations .deviations-header {
  padding: 16px 24px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.DriveTimeDeviations .deviations-header:hover {
  background-color: #f8f9fa;
}
.DriveTimeDeviations .deviations-header .header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.DriveTimeDeviations .deviations-header .header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}
.DriveTimeDeviations .deviations-header .header-left .chart-icon {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.DriveTimeDeviations .deviations-header .header-left .chart-icon i {
  font-size: 16px;
  color: #333;
}
.DriveTimeDeviations .deviations-header .header-left .header-text .header-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0 0 2px 0;
}
.DriveTimeDeviations .deviations-header .header-left .header-text .header-subtitle {
  font-size: 14px;
  color: #666;
  margin: 0;
}
.DriveTimeDeviations .deviations-header .collapse-icon {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.DriveTimeDeviations .deviations-header .collapse-icon i {
  font-size: 14px;
  color: #666;
  transition: transform 0.2s ease;
}
.DriveTimeDeviations .deviations-content {
  border-top: 1px solid #e0e0e0;
  padding: 24px;
}
.DriveTimeDeviations .deviations-content .chart-section .chart-header {
  margin-bottom: 24px;
}
.DriveTimeDeviations .deviations-content .chart-section .chart-header .chart-header-left {
  display: flex;
  align-items: center;
  gap: 8px;
}
.DriveTimeDeviations .deviations-content .chart-section .chart-header .chart-header-left .chart-icon-small {
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.DriveTimeDeviations .deviations-content .chart-section .chart-header .chart-header-left .chart-icon-small i {
  font-size: 14px;
  color: #333;
}
.DriveTimeDeviations .deviations-content .chart-section .chart-header .chart-header-left .chart-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0;
}
.DriveTimeDeviations .deviations-content .chart-section .chart-header .chart-header-left .info-icon {
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.DriveTimeDeviations .deviations-content .chart-section .chart-header .chart-header-left .info-icon i {
  font-size: 12px;
  color: #6c757d;
}
.DriveTimeDeviations .deviations-content .chart-section .chart-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  background: #f8f9fa;
  border-radius: 8px;
  padding: 40px 20px;
  text-align: center;
}
.DriveTimeDeviations .deviations-content .chart-section .chart-placeholder .chart-icon-large {
  margin-bottom: 20px;
}
.DriveTimeDeviations .deviations-content .chart-section .chart-placeholder .chart-icon-large i {
  font-size: 48px;
  color: #6c757d;
  background: #e9ecef;
  padding: 24px;
  border-radius: 8px;
  width: 96px;
  height: 96px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.DriveTimeDeviations .deviations-content .chart-section .chart-placeholder .placeholder-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
  max-width: 400px;
}
.DriveTimeDeviations .deviations-content .chart-section .chart-placeholder .placeholder-description {
  font-size: 14px;
  color: #666;
  margin: 0;
  line-height: 1.5;
  max-width: 350px;
}
@media (max-width: 768px) {
  .DriveTimeDeviations .deviations-header {
    padding: 12px 16px;
  }
  .DriveTimeDeviations .deviations-header .header-left {
    gap: 8px;
  }
  .DriveTimeDeviations .deviations-header .header-left .header-text .header-title {
    font-size: 15px;
  }
  .DriveTimeDeviations .deviations-header .header-left .header-text .header-subtitle {
    font-size: 13px;
  }
  .DriveTimeDeviations .deviations-content {
    padding: 16px;
  }
  .DriveTimeDeviations .deviations-content .chart-section .chart-placeholder {
    padding: 20px 16px;
    min-height: 250px;
  }
  .DriveTimeDeviations .deviations-content .chart-section .chart-placeholder .chart-icon-large i {
    font-size: 40px;
    width: 80px;
    height: 80px;
    padding: 20px;
  }
  .DriveTimeDeviations .deviations-content .chart-section .chart-placeholder .placeholder-title {
    font-size: 16px;
  }
  .DriveTimeDeviations .deviations-content .chart-section .chart-placeholder .placeholder-description {
    font-size: 13px;
  }
}`, "",{"version":3,"sources":["webpack://./src/features/DriveTimeTool/components/DriveTimeDeviations/styles.scss"],"names":[],"mappings":"AACE;EACE,yBAAA;EACA,kBAAA;EACA,wCAAA;EACA,gBAAA;AAAJ;AAEI;EACE,UAAA;AAAN;AAIE;EACE,kBAAA;EACA,eAAA;EACA,sCAAA;AAFJ;AAII;EACE,yBAAA;AAFN;AAKI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAHN;AAMI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAJN;AAMM;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAJR;AAMQ;EACE,eAAA;EACA,WAAA;AAJV;AASQ;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;AAPV;AAUQ;EACE,eAAA;EACA,WAAA;EACA,SAAA;AARV;AAaI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAXN;AAaM;EACE,eAAA;EACA,WAAA;EACA,+BAAA;AAXR;AAgBE;EACE,6BAAA;EACA,aAAA;AAdJ;AAiBM;EACE,mBAAA;AAfR;AAiBQ;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAfV;AAiBU;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAfZ;AAiBY;EACE,eAAA;EACA,WAAA;AAfd;AAmBU;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,SAAA;AAjBZ;AAoBU;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAlBZ;AAoBY;EACE,eAAA;EACA,cAAA;AAlBd;AAwBM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AAtBR;AAwBQ;EACE,mBAAA;AAtBV;AAwBU;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AAtBZ;AA0BQ;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;AAxBV;AA2BQ;EACE,eAAA;EACA,WAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;AAzBV;AA+BE;EACE;IACE,kBAAA;EA7BJ;EA+BI;IACE,QAAA;EA7BN;EAgCQ;IACE,eAAA;EA9BV;EAiCQ;IACE,eAAA;EA/BV;EAqCE;IACE,aAAA;EAnCJ;EAsCM;IACE,kBAAA;IACA,iBAAA;EApCR;EAsCQ;IACE,eAAA;IACA,WAAA;IACA,YAAA;IACA,aAAA;EApCV;EAuCQ;IACE,eAAA;EArCV;EAwCQ;IACE,eAAA;EAtCV;AACF","sourcesContent":[".DriveTimeDeviations {\n  .deviations-card {\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    overflow: hidden;\n\n    .card-body {\n      padding: 0;\n    }\n  }\n\n  .deviations-header {\n    padding: 16px 24px;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n\n    &:hover {\n      background-color: #f8f9fa;\n    }\n\n    .header-content {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n    }\n\n    .header-left {\n      display: flex;\n      align-items: center;\n      gap: 12px;\n\n      .chart-icon {\n        width: 20px;\n        height: 20px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        i {\n          font-size: 16px;\n          color: #333;\n        }\n      }\n\n      .header-text {\n        .header-title {\n          font-size: 16px;\n          font-weight: 600;\n          color: #333;\n          margin: 0 0 2px 0;\n        }\n\n        .header-subtitle {\n          font-size: 14px;\n          color: #666;\n          margin: 0;\n        }\n      }\n    }\n\n    .collapse-icon {\n      width: 20px;\n      height: 20px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      i {\n        font-size: 14px;\n        color: #666;\n        transition: transform 0.2s ease;\n      }\n    }\n  }\n\n  .deviations-content {\n    border-top: 1px solid #e0e0e0;\n    padding: 24px;\n\n    .chart-section {\n      .chart-header {\n        margin-bottom: 24px;\n\n        .chart-header-left {\n          display: flex;\n          align-items: center;\n          gap: 8px;\n\n          .chart-icon-small {\n            width: 18px;\n            height: 18px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n\n            i {\n              font-size: 14px;\n              color: #333;\n            }\n          }\n\n          .chart-title {\n            font-size: 16px;\n            font-weight: 600;\n            color: #333;\n            margin: 0;\n          }\n\n          .info-icon {\n            width: 16px;\n            height: 16px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n\n            i {\n              font-size: 12px;\n              color: #6c757d;\n            }\n          }\n        }\n      }\n\n      .chart-placeholder {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        min-height: 300px;\n        background: #f8f9fa;\n        border-radius: 8px;\n        padding: 40px 20px;\n        text-align: center;\n\n        .chart-icon-large {\n          margin-bottom: 20px;\n\n          i {\n            font-size: 48px;\n            color: #6c757d;\n            background: #e9ecef;\n            padding: 24px;\n            border-radius: 8px;\n            width: 96px;\n            height: 96px;\n            display: inline-flex;\n            align-items: center;\n            justify-content: center;\n          }\n        }\n\n        .placeholder-title {\n          font-size: 18px;\n          font-weight: 600;\n          color: #333;\n          margin-bottom: 12px;\n          max-width: 400px;\n        }\n\n        .placeholder-description {\n          font-size: 14px;\n          color: #666;\n          margin: 0;\n          line-height: 1.5;\n          max-width: 350px;\n        }\n      }\n    }\n  }\n\n  @media (max-width: 768px) {\n    .deviations-header {\n      padding: 12px 16px;\n\n      .header-left {\n        gap: 8px;\n\n        .header-text {\n          .header-title {\n            font-size: 15px;\n          }\n\n          .header-subtitle {\n            font-size: 13px;\n          }\n        }\n      }\n    }\n\n    .deviations-content {\n      padding: 16px;\n\n      .chart-section {\n        .chart-placeholder {\n          padding: 20px 16px;\n          min-height: 250px;\n\n          .chart-icon-large i {\n            font-size: 40px;\n            width: 80px;\n            height: 80px;\n            padding: 20px;\n          }\n\n          .placeholder-title {\n            font-size: 16px;\n          }\n\n          .placeholder-description {\n            font-size: 13px;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
